import NamedDto from 'modules/base/dto/NamedDto';

export class Lummus2ModelComponentEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {number} */
		this.value = null;
	}

	/**
	 * @typedef {Object} _Lummus2ModelComponentEditDtoProps
	 * @property {number} value
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _Lummus2ModelComponentEditDtoProps} Lummus2ModelComponentEditDtoProps
	 */
	/**
	 *
	 * @param {Lummus2ModelComponentEditDtoProps} props
	 * @returns {Lummus2ModelComponentEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.value = props.value;
		return this;
	}
}

export default Lummus2ModelComponentEditDto;
